export default __webpack_public_path__ + "static/media/snowman.4940dfb8.svg";